import { fetch } from '@maxtropy/components';

export function getDefaultKey(): Promise<Record<string, string>> {
  return fetch(`/api/v2/file-center/defaultKey`);
}
